import { Component } from '@angular/core';
import { PrimaryButtonComponent } from '../primary-button.component';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['../button.component.scss', './back-button.component.scss'],
})
export class BackButtonComponent extends PrimaryButtonComponent {
  constructor() {
    super();
    this.outline = true;
  }
}
